import { TextField, WithStyles } from '@material-ui/core';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { InjectedFormikProps, withFormik } from 'formik';
import * as React from 'react';
import * as Yup from 'yup';
import MyButton from '../UI/MyButton/MyButton';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    textField: {
      margin: '0',
      marginBottom: '1rem',
      width: '100%'
    },
    textInput: {
      textTransform: 'capitalize'
    }
  });

interface IFormValues {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

interface IFormProps extends WithStyles<typeof styles> {
  onSubmit: (values: any) => void;
}

const InnerForm: React.SFC<
  InjectedFormikProps<IFormProps, IFormValues>
> = props => (
  <div>
    <form onSubmit={props.handleSubmit}>
      <div>
        <TextField
          id="oldPassword"
          error={Boolean(props.errors.oldPassword && props.touched.oldPassword)}
          label="Old Password"
          onChange={props.handleChange}
          value={props.values.oldPassword}
          type={'password'}
          margin="normal"
          className={props.classes.textField}
          helperText={
            props.errors.oldPassword &&
            props.touched.oldPassword &&
            String(props.errors.oldPassword)
          }
          InputLabelProps={{
            shrink: true
          }}
        />
        <TextField
          id="newPassword"
          error={Boolean(props.errors.newPassword && props.touched.newPassword)}
          label="New Password"
          onChange={props.handleChange}
          value={props.values.newPassword}
          type={'password'}
          margin="normal"
          className={props.classes.textField}
          helperText={
            props.errors.newPassword &&
            props.touched.newPassword &&
            String(props.errors.newPassword)
          }
          InputLabelProps={{
            shrink: true
          }}
        />
        <TextField
          id="confirmNewPassword"
          error={Boolean(
            props.errors.confirmNewPassword && props.touched.confirmNewPassword
          )}
          label="Confirm Password"
          onChange={props.handleChange}
          value={props.values.confirmNewPassword}
          margin="normal"
          className={props.classes.textField}
          helperText={
            props.errors.confirmNewPassword &&
            props.touched.confirmNewPassword &&
            String(props.errors.confirmNewPassword)
          }
          InputLabelProps={{
            shrink: true
          }}
        />

        <MyButton
          btnType={'yellow'}
          className={props.classes.textField}
          type="submit"
          disabled={props.isSubmitting}
        >
          Save
        </MyButton>
      </div>
    </form>
  </div>
);

const ChangePasswordForm = withFormik<IFormProps, IFormValues>({
  mapPropsToValues: props => {
    return {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    };
  },
  validationSchema: Yup.object().shape({
    oldPassword: Yup.string()
      .required('*Required')
      .min(6, 'Must be at least 6 characters'),
    newPassword: Yup.string()
      .required('*Required')
      .min(6, 'Must be at least 6 characters'),
    confirmNewPassword: Yup.string()
      .required('*Required')
      .oneOf([Yup.ref('newPassword'), null], "Passwords don't match!")
  }),
  validate: () => {
    const errors: any = {};
    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default withStyles(styles)(ChangePasswordForm);
